module.exports = "https://cdn.realtymogul.com/static/media/social_fb_gray.34b16489.svg";